(function () {
    "use strict";

    var UserSelectorControl = Solovis.defineClass(
        "Solovis.InvDataSelectors.UserSelectorControl",
        Solovis.UI.BaseControl,
        function (options) {
            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;
        });
    

    UserSelectorControl.prototype.doInit = function () {
    };

    UserSelectorControl.prototype.doRender = function () {
        var self = this;

        function findItems(autocompleteRequest, responseCallback) {
            Solovis.Rpc.invoke("~/Selectors/UserSelector/FindUser", { filterText: autocompleteRequest.term, maxItems: 10 },
                function (response, success) {
                    if (success) {
                        responseCallback(response.result);
                    }
                    else {
                        // TODO: report error somehow
                        responseCallback([]);
                    }
                });
        }

        this.searchBox = $("<input>").attr("type", "text").appendTo(this.container);

        var getLabelForItem = function (item) {
            return item.fullName + " - " + item.primaryEmail;
        };

        this.searchBox.autocomplete({
            minLength: 1,
            source: findItems,
            focus: function (event, ui) {
                if (ui.item)
                    self.searchBox.val(getLabelForItem(ui.item));
                return false;
            },
            select: function (event, ui) {
                if (ui.item) {
                    self.searchBox.val(getLabelForItem(ui.item));
                    var item = ui.item;

                    if (self.selectionCallback) {
                        self.selectionCallback(item);
                    }
                }
                return false;
            }
        })
        .data("ui-autocomplete")._renderItem = function (ul, item) {
            var label = getLabelForItem(item);

            var itemLink = $("<a>").text(label);
            var itemElement = $("<li>").append(itemLink);
            itemElement.appendTo(ul);
            return itemElement;
        };

        // Trigger cancel when escape is pressed.
        $(this.searchBox).keyup(function (e) {
            if (e.keyCode == 27) {
                // Escape was pressed.
                if (self.cancelCallback) {
                    self.cancelCallback();
                }
            }
        });
    };

    UserSelectorControl.prototype.focus = function () {
        if (this.searchBox) {
            this.searchBox.focus();
        }
    };


})();